import { Empty } from "antd";

export const NoContentFound: React.FC<{ description?: string }> = ({
  description,
}) => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={description ?? "No options available"}
      style={{
        textAlign: "center",
      }}
    />
  );
};
